// Styles
import './shop-by-look.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initShopByLook = (context) => {
  const shopByLookSection = context.closest('.shopify-section');
  if (!shopByLookSection) return;

  const lookBlocks = shopByLookSection.querySelector('.look-blocks');
  if(!lookBlocks) return;

  const shopByLookSwiper = new Swiper(lookBlocks, {
    loop: true,

    navigation: {
      nextEl: shopByLookSection.querySelector('.look-arrow.right'),
      prevEl: shopByLookSection.querySelector('.look-arrow.left'),
    }
  });
}

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.shop-by-look'), (el) => {
    window.dAgency.initShopByLook(el);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.shop-by-look'), (el) => {
      window.dAgency.initShopByLook(el);
    });
  });
}
